import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { fetchQuizTypes } from '../Core/FetchData';
import { convertToRoman } from '../Core/Functions';

import VideoLightbox from './VideoLightbox';
import HtmlWithIcons from '../Utilites/HtmlWithIcons';
import './QuizSelection.css';

const QUIZ_GRID_WIDTH = 648; // Four 144 px circles and three 24 px gaps.

const QuizSelection = ({ onChange, lang, area }) => { 
    const navigate = useNavigate();

    const [quizzes, setQuizzes] = useState([]); 
    const [visibleQuizzes, setVisibleQuizzes] = useState([]);
    const gridRef = useRef(null);

    useLayoutEffect(() => {
        const grid = gridRef.current;
        const updateScale = () => {
            const width = grid.getBoundingClientRect().width;
            if (width > 0) {
                grid.style.setProperty('--quiz-scale', Math.min(1, width / QUIZ_GRID_WIDTH));
            }
        };

        updateScale();
        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', updateScale);
            return () => window.removeEventListener('resize', updateScale);
        }

        const observer = new ResizeObserver(updateScale);
        observer.observe(grid);
        return () => observer.disconnect();
    }, []);

    const changeQuiz = (quiz) => {
        onChange(quiz); 
        
        // Rozlišení podle typu
        if (quiz.type === 'textCompletion') {
            navigate('/quiz/select-level');
        } else {
            navigate('/quiz/play');
        }
    };


    useEffect(() => {
        if (!area.id) {
            navigate('/quiz/select-area');
        }
    }, [area, navigate]);


    // nacteni dostupnych oblasti z API
        useEffect(() => {
            const loadQuizzes = async () => {
                let fetchedQuizzes = await fetchQuizTypes(lang, area); 

                const hasText =
                    area.textA2?.trim() ||
                    area.textB1?.trim() ||
                    area.textB2?.trim() ||
                    area.textC1?.trim();

                if (!hasText) {
                    fetchedQuizzes = fetchedQuizzes.filter(q => q.type !== 'textCompletion');
                }


                setQuizzes(fetchedQuizzes); 
            };
            loadQuizzes();
        }, [lang, area]);

    // Zobrazení tlačítek jedno po druhém
        useEffect(() => {
            quizzes.forEach((quiz, quizIndex) => {
            setTimeout(() => {
                setVisibleQuizzes((prev) => [...prev, quiz.id]);
            }, quizIndex * 100); // 200ms zpoždění mezi tlačítky
            });
        }, [quizzes]);


        return (
            <div id="quiz-quizzesSelection">

                <VideoLightbox video={area.video} />

                <ul ref={gridRef} className="quiz-grid" style={{ '--quiz-grid-width': `${QUIZ_GRID_WIDTH}px` }}>
                    {quizzes && quizzes.length > 0 && quizzes.map((quiz) => {
                
                        return (
                            <li key={`quiz-${area.id}-${quiz.id}`}>
                                <div className="quiz-tile">
                                <button
                                    onClick={() => changeQuiz(quiz)}
                                    className={`btn-primary flex-col !p-6 w-full transition-transform transform ${visibleQuizzes.includes(quiz.id) ? 'opacity-100' : 'opacity-0'}`}
                                    style={{ transitionDuration: '0.5s' }} // Animace tlačítek
                                >
                                    {area.title}
                                    <strong className="flex items-center text-[4rem] h-16 font-bold text-shadow pt-2">{convertToRoman(quiz.number)}.</strong>
                                    <div className="alt-name"><HtmlWithIcons html={quiz.name_alt} /></div>
                                </button>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
}

export default QuizSelection;
